import { useCallback } from "react";
import PropTypes from "prop-types";

const FooterLinks = ({ className = "" }) => {
  const onAboutUsTextClick = useCallback(() => {
    // Please sync "Landing Page/About Us" to the project
  }, []);

  const onJourneyTextClick = useCallback(() => {
    // Please sync "Landing Page/Journey" to the project
  }, []);

  const onBlogTextClick = useCallback(() => {
    // Please sync "Landing Page/Blog" to the project
  }, []);

  const onHelpTextClick = useCallback(() => {
    // Please sync "Landing Page/Help" to the project
  }, []);

  return (
    <div
      className={`flex-1 flex flex-row items-start justify-between min-w-[463px] max-w-full gap-5 text-left text-base text-base-content font-body-m mq1050:flex-wrap mq1050:min-w-full ${className}`}
    >
      <div className="flex flex-col items-start justify-start py-0 pl-0 pr-[13px] gap-4">
        <div className="relative leading-[24px] font-semibold">Companies</div>
        <div className="flex flex-col items-start justify-start gap-3 text-center text-sm text-base-content/70">
          <a
            className="[text-decoration:none] self-stretch relative leading-[20px] text-[inherit] inline-block min-w-[64px] cursor-pointer"
            onClick={onAboutUsTextClick}
          >
            About Us
          </a>
          <div
            className="w-[58px] relative leading-[20px] inline-block cursor-pointer"
            onClick={onJourneyTextClick}
          >
            Journey
          </div>
          <div
            className="w-8 relative leading-[20px] inline-block cursor-pointer"
            onClick={onBlogTextClick}
          >
            Blog
          </div>
          <div className="w-[58px] relative leading-[20px] inline-block">
            Contact
          </div>
          <div
            className="w-[33px] relative leading-[20px] inline-block cursor-pointer"
            onClick={onHelpTextClick}
          >
            Help
          </div>
        </div>
      </div>
      <div className="flex flex-col items-start justify-start py-0 pl-0 pr-5 gap-4">
        <div className="relative leading-[24px] font-semibold inline-block min-w-[86px]">
          Resources
        </div>
        <div className="flex flex-col items-start justify-start gap-3 text-center text-sm text-base-content/70">
          <a
            className="[text-decoration:none] self-stretch relative leading-[20px] text-[inherit] inline-block min-w-[64px] cursor-pointer"
            onClick={onAboutUsTextClick}
          >
            About Us
          </a>
          <div
            className="w-[58px] relative leading-[20px] inline-block cursor-pointer"
            onClick={onJourneyTextClick}
          >
            Journey
          </div>
          <div
            className="w-8 relative leading-[20px] inline-block cursor-pointer"
            onClick={onBlogTextClick}
          >
            Blog
          </div>
          <div className="w-[58px] relative leading-[20px] inline-block">
            Contact
          </div>
          <div
            className="w-[33px] relative leading-[20px] inline-block cursor-pointer"
            onClick={onHelpTextClick}
          >
            Help
          </div>
        </div>
      </div>
      <div className="flex flex-col items-start justify-start gap-4">
        <div className="relative leading-[24px] font-semibold">Help</div>
        <div className="self-stretch flex flex-col items-start justify-start gap-3 text-center text-sm text-base-content/70">
          <div className="w-[86px] relative leading-[20px] inline-block">
            House Rules
          </div>
          <a className="[text-decoration:none] w-[74px] relative leading-[20px] text-[inherit] inline-block">
            Our Terms
          </a>
          <a className="[text-decoration:none] self-stretch relative leading-[20px] text-[inherit]">{`Privacy & Policy`}</a>
        </div>
      </div>
      <div className="flex flex-col items-start justify-start gap-4">
        <div className="relative leading-[24px] font-semibold">Contact Us</div>
        <div className="flex flex-col items-start justify-start gap-3 text-center text-sm text-base-content/70">
          <div className="flex flex-row items-start justify-start gap-3">
            <img className="h-6 w-6 relative" alt="" src="/essentional-1.svg" />
            <div className="flex-1 relative leading-[20px] inline-block min-w-[109px]">
              (480) 555-0103
            </div>
          </div>
          <div className="flex flex-row items-start justify-start gap-3">
            <img
              className="h-5 w-5 relative"
              loading="lazy"
              alt=""
              src="/location.svg"
            />
            <div className="relative leading-[20px]">
              6391 Elgin St.Celina, Delaware 10299
            </div>
          </div>
          <div className="flex flex-row items-center justify-start gap-3">
            <img className="h-5 w-5 relative" alt="" src="/message-3.svg" />
            <a
              className="flex-1 relative leading-[20px] text-[inherit] [text-decoration:none]"
              href="mailto:hub@tradiant.com"
              target="_blank"
            >
              hub@tradiant.com
            </a>
          </div>
        </div>
      </div>
    </div>
  );
};

FooterLinks.propTypes = {
  className: PropTypes.string,
};

export default FooterLinks;
